// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const yak = defineModel({
  id: "yak",
  scale: 4.27, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Yak",
  tags: ["creature","yak","low-poly","age-of-mcp","future"],
  summary: "A yak — wool, milk, meat and high-altitude pack power.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.13,
  fits: ["draft"],
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.01, 0.045, 5), color: "#3c3026", position: [0.05, 0.022, 0.04] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.01, 0.045, 5), color: "#3c3026", position: [0.05, 0.022, -0.04] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.01, 0.045, 5), color: "#3c3026", position: [-0.05, 0.022, 0.04] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.01, 0.045, 5), color: "#3c3026", position: [-0.05, 0.022, -0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.062, 0), color: "#5a4a3c", position: [0, 0.095, 0], scale: [1.6, 1, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#4a3c30", position: [0, 0.062, 0], scale: [1.55, 0.7, 1.25] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#6b5847", position: [0.085, 0.105, 0], scale: [1.05, 1, 1] },
      { geometry: new THREE.BoxGeometry(0.03, 0.022, 0.028), color: "#6b5847", position: [0.114, 0.096, 0] },
      { geometry: new THREE.ConeGeometry(0.009, 0.04, 5), color: "#cfc4ac", position: [0.078, 0.142, 0.026], rotation: [0.7, 0, 0.5] },
      { geometry: new THREE.ConeGeometry(0.009, 0.04, 5), color: "#cfc4ac", position: [0.078, 0.142, -0.026], rotation: [-0.7, 0, 0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#5a4a3c", position: [0.07, 0.135, 0], scale: [1, 0.8, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.1, 0.112, 0.02] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.1, 0.112, -0.02] },
      { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#4a3c30", position: [-0.09, 0.07, 0], scale: [0.8, 1.4, 0.8] },
    ],
  animations: [],
});
